import {getFactionConfig} from "./getFactionConfig";
import {LEAGUES} from "../../constants/leagues";

/**
 * Тексты ранговых образов. Образы выдаются за три высшие лиги (см.
 * RANK_SKIN_LEAGUES и calculateRankSkinRewards на сервере), редкость у них
 * разная — отсюда разные слова: золото < алмаз < рубин. Цвет подсветки
 * берется отдельно из RANK_NAME_COLORS (constants/factions.js), чтобы не
 * дублировать палитру.
 *
 * rarity/rarityFeminine/rarityNeuter — одно и то же прилагательное в мужском
 * («образ»), женском («победа») и среднем («обличие») роде;
 * leagueAdjectiveGenitive — прилагательное лиги в родительном падеже, к
 * которому текст сам дописывает « лиги».
 */
export const RANK_SKIN_DISPLAY = {
  [LEAGUES.GOLD]: {
    rarity: 'эпический',
    rarityFeminine: 'эпической',
    rarityNeuter: 'эпическое',
    leagueName: 'Золотая Лига',
    leagueGenitive: 'Золотой Лиги',
    leagueAdjectiveGenitive: 'Золотой',
  },
  [LEAGUES.DIAMOND]: {
    rarity: 'героический',
    rarityFeminine: 'героической',
    rarityNeuter: 'героическое',
    leagueName: 'Алмазная Лига',
    leagueGenitive: 'Алмазной Лиги',
    leagueAdjectiveGenitive: 'Алмазной',
  },
  [LEAGUES.RUBY]: {
    rarity: 'легендарный',
    rarityFeminine: 'легендарной',
    rarityNeuter: 'легендарное',
    leagueName: 'Рубиновая Лига',
    leagueGenitive: 'Рубиновой Лиги',
    leagueAdjectiveGenitive: 'Рубиновой',
  },
};

/**
 * Человекочитаемое название рангового образа фракции для подсказки (title/alt).
 * Идентификатор образа (`humans_gold`) для игрока бессмысленен, поэтому в UI
 * показывается название вида «Люди: эпический образ Золотой Лиги».
 *
 * @param {string} factionId - идентификатор фракции (`humans`)
 * @param {string} rank - лига образа (`gold` | `diamond` | `ruby`)
 * @returns {string} название для подсказки
 */
export const getFactionRankSkinTitle = (factionId, rank) => {
  const factionName = getFactionConfig(factionId)?.name || factionId;
  const display = RANK_SKIN_DISPLAY[rank];

  // Неизвестная лига (новая или битый id образа) — показываем хотя бы фракцию,
  // но не сырой англоязычный идентификатор
  if (!display) {
    return factionName;
  }

  return `${factionName}: ${display.rarity} образ ${display.leagueGenitive}`;
};

/**
 * Разбор идентификатора рангового образа (`humans_gold`, `dark_elves_ruby`):
 * лига — всегда последний сегмент, остальное — id фракции (у части фракций он
 * сам содержит подчеркивание).
 *
 * @param {string} skinId
 * @returns {{factionId: string, rank: string}}
 */
export const parseRankSkinId = (skinId) => {
  const parts = String(skinId || '').split('_');
  return {
    rank: parts[parts.length - 1],
    factionId: parts.slice(0, parts.length - 1).join('_'),
  };
};
